import { useNavigate } from 'react-router-dom';

import { navigateToVistProfile } from 'components/admin/pages/Practices/lib/helpers';
import Badge from 'components/shared/Badge/Badge';

const FullNameCell = ({ data, principalUserId }) => {
  const navigate = useNavigate();
  const { user_id, f_name, m_name, l_name } = data;
  const isPrincipal = principalUserId && user_id === principalUserId;

  return (
    <div
      onClick={() => navigateToVistProfile(navigate, user_id)}
      style={{ cursor: 'pointer' }}
      className="flex items-center gap-1.5">
      {f_name} {m_name && `${m_name} `} {l_name}
      {isPrincipal && <Badge text="Principal" size="small" color="danger" variant="light" />}
    </div>
  );
};

export default FullNameCell;
